module.exports = __webpack_public_path__ + "static/media/loading.72bd1e8b.svg";